import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["glyph", "container", "status"]
  static values = {
    stadiumCode: String,
    thingId: String
  }

  connect() {
    requestAnimationFrame(() => this.safeRender(1))
  }

  safeRender(attempt = 1) {
    if (!this.stadiumCodeValue || !this.thingIdValue) {
      if (attempt > 10) {
        console.error("❌ Still missing stadium code or thing ID after 10 attempts.")
        return
      }
      console.warn(`🕳️ Attempt ${attempt}: Missing stadium code or thing ID, retrying...`)
      setTimeout(() => this.safeRender(attempt + 1), 100)
      return
    }

    this.renderQRCode()
    this.renderGlyph()
    this.verifyStadium?.()
  }

  renderQRCode() {
    if (!this.hasContainerTarget || !this.stadiumCodeValue) return

    if (!window.QRCode) {
      console.error("❌ QRCode is not defined on window. Ensure QRCode library is loaded.")
      return
    }

    const qrContainer = this.containerTarget
    qrContainer.innerHTML = ""

    new window.QRCode(qrContainer, {
      text: this.stadiumCodeValue,
      width: 300,
      height: 300,
      colorDark: "#000",
      colorLight: "#fff",
      correctLevel: window.QRCode.CorrectLevel.H
    })
  }

  renderGlyph() {
    if (this.hasGlyphTarget && this.stadiumCodeValue) {
      const glyphs = this.convertToSymbols(this.stadiumCodeValue)
      this.glyphTarget.innerHTML = glyphs
        .map((glyph) => `<span class="glyph-token">${glyph}</span>`)
        .join("")
    }
  }

  convertToSymbols(code) {
    const BASE11_SYMBOLS = {
      "0": "🛸", "1": "🌚", "2": "☄️", "3": "🐦‍⬛",
      "4": "🐳", "5": "🐇", "6": "🪙", "7": "🍦",
      "8": "⚪", "9": "🌝"
    }
    return code.split("").map(char => BASE11_SYMBOLS[char] || char)
  }

  disconnect() {
    if (this.hasContainerTarget) this.containerTarget.innerHTML = ""
    if (this.hasGlyphTarget) this.glyphTarget.innerText = ""
  }
}
